// Mas informacion de los colores en index.css
const colores = {
  bGreen: {
    50: 'var(--bGreen-50)',
    100: 'var(--bGreen-100)',
    200: 'var(--bGreen-200)',
    300: 'var(--bGreen-300)',
    400: 'var(--bGreen-400)',
    500: 'var(--bGreen-500)',
    600: 'var(--bGreen-600)', // Default
    700: 'var(--bGreen-700)',
    800: 'var(--bGreen-800)',
    900: 'var(--bGreen-900)',
    950: 'var(--bGreen-950)',
  },
  bPink: {
    50: 'var(--bPink-50)',
    100: 'var(--bPink-100)',
    200: 'var(--bPink-200)',
    300: 'var(--bPink-300)',
    400: 'var(--bPink-400)',
    500: 'var(--bPink-500)',
    600: 'var(--bPink-600)', // Default
    700: 'var(--bPink-700)',
    800: 'var(--bPink-800)',
    900: 'var(--bPink-900)',
    950: 'var(--bPink-950)',
  },
  bBlue: {
    50: 'var(--bBlue-50)',
    100: 'var(--bBlue-100)',
    200: 'var(--bBlue-200)',
    300: 'var(--bBlue-300)',
    400: 'var(--bBlue-400)',
    500: 'var(--bBlue-500)', // Default
    600: 'var(--bBlue-600)', 
    700: 'var(--bBlue-700)',
    800: 'var(--bBlue-800)',
    900: 'var(--bBlue-900)',
    950: 'var(--bBlue-950)',
  },
  bMint: {
    50: 'var(--bMint-50)',
    100: 'var(--bMint-100)',
    200: 'var(--bMint-200)',
    300: 'var(--bMint-300)', // Default
    400: 'var(--bMint-400)',
    500: 'var(--bMint-500)',
    600: 'var(--bMint-600)',
    700: 'var(--bMint-700)',
    800: 'var(--bMint-800)',
    900: 'var(--bMint-900)',
    950: 'var(--bMint-950)',
  },
  bPurple: {
    50: 'var(--bPurple-50)',
    100: 'var(--bPurple-100)',
    200: 'var(--bPurple-200)',
    300: 'var(--bPurple-300)',
    400: 'var(--bPurple-400)',
    500: 'var(--bPurple-500)', // Default
    600: 'var(--bPurple-600)',
    700: 'var(--bPurple-700)',
    800: 'var(--bPurple-800)',
    900: 'var(--bPurple-900)',
    950: 'var(--bPurple-950)',
  },
  bOrange: {
    50: 'var(--bOrange-50)',
    100: 'var(--bOrange-100)',
    200: 'var(--bOrange-200)',
    300: 'var(--bOrange-300)',
    400: 'var(--bOrange-400)',
    500: 'var(--bOrange-500)', // Default
    600: 'var(--bOrange-600)',
    700: 'var(--bOrange-700)',
    800: 'var(--bOrange-800)',
    900: 'var(--bOrange-900)',
    950: 'var(--bOrange-950)',
  },
  compo: {
    50: 'var(--compo-50)',
    100: 'var(--compo-100)',
    200: 'var(--compo-200)', // Default
    300: 'var(--compo-300)',
    400: 'var(--compo-400)',
    500: 'var(--compo-500)',
    600: 'var(--compo-600)',
    700: 'var(--compo-700)',
    800: 'var(--compo-800)',
    900: 'var(--compo-900)',
    950: 'var(--compo-950)',
  },
  destructive: {
    50: 'var(--destructive-50)',
    100: 'var(--destructive-100)',
    200: 'var(--destructive-200)',
    300: 'var(--destructive-300)',
    400: 'var(--destructive-400)', // Default
    500: 'var(--destructive-500)',
    600: 'var(--destructive-600)',
    700: 'var(--destructive-700)',
    800: 'var(--destructive-800)',
    900: 'var(--destructive-900)',
    950: 'var(--destructive-950)',
  },
  foreground: 'var(--foreground)',
  'foreground-secondary': 'var(--foreground-secondary)',
  layout: 'var(--layout)',
  background: 'var(--background)',
};

export default colores